import React from 'react';
import { Card } from './ui/card';
import { CheckCircle2 } from 'lucide-react';

const About = ({ profile }) => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
              About {profile?.nameWithCredentials || profile?.name}
            </h2>
            <div className="w-24 h-1 bg-teal-600 mx-auto rounded-full"></div>
          </div>
          
          <Card className="p-8 sm:p-10 border-slate-200 shadow-lg hover:shadow-xl transition-shadow duration-300">
            <p className="text-lg text-slate-700 leading-relaxed mb-6">
              {profile?.about?.description}
            </p>
            
            {profile?.about?.ashTraining && (
              <p className="text-lg text-slate-700 leading-relaxed mb-8 p-4 bg-teal-50 rounded-lg border-l-4 border-teal-600">
                {profile?.about?.ashTraining}
              </p>
            )}
            
            <div className="grid sm:grid-cols-2 gap-6">
              <div className="space-y-3">
                <h3 className="text-xl font-semibold text-slate-900 mb-4">Qualifications</h3>
                {profile?.about?.qualifications?.map((qual, idx) => (
                  <div key={idx} className="flex items-start space-x-3">
                    <CheckCircle2 className="w-5 h-5 text-teal-600 mt-0.5 flex-shrink-0" />
                    <span className="text-slate-700">{qual}</span>
                  </div>
                ))}
              </div>
              
              <div className="space-y-3">
                <h3 className="text-xl font-semibold text-slate-900 mb-4">Experience</h3>
                <div className="flex items-start space-x-3">
                  <CheckCircle2 className="w-5 h-5 text-teal-600 mt-0.5 flex-shrink-0" />
                  <span className="text-slate-700">{profile?.about?.experience} in Pediatric Hematology & Oncology</span>
                </div>
                <div className="flex items-start space-x-3">
                  <CheckCircle2 className="w-5 h-5 text-teal-600 mt-0.5 flex-shrink-0" />
                  <span className="text-slate-700">Specialized training in BMT procedures</span>
                </div>
                <div className="flex items-start space-x-3">
                  <CheckCircle2 className="w-5 h-5 text-teal-600 mt-0.5 flex-shrink-0" />
                  <span className="text-slate-700">Expert in CAR-T cell therapy</span>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default About;